import gettext from '@sdk/lang/gettext';
import InfoModal from '@sdk/components/ui/InfoModal/InfoModal';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';

import ExclamationMarkIcon from '@web/assets/svg/UI/exclamation-mark.svg';

import { Description, IconWrapper } from './bulkModeSubmitError.styles';

type Props = {
  onClose: () => void;
};

export const BulkModeSubmitError = ({ onClose }: Props) => (
  <InfoModal
    buttonsPadding={0}
    fullScreen
    titleText={gettext('Exceeding the number of recipients')}
    titleThemeColor={ThemeColorType.danger}
    titleIcon={
      <IconWrapper>
        <ExclamationMarkIcon aria-hidden={true} />
      </IconWrapper>
    }
    buttonText={gettext('Got it')}
    dismiss={onClose}
    zIndex={1045}>
    <Description>
      {gettext('You exceeded the maximum recipients. Reduce the list to below 1,000 to continue.')}
    </Description>
  </InfoModal>
);
